import { useEffect, useLayoutEffect } from "react"
import { useLocation } from "react-router-dom"
import esCatalog from "@/i18n/locales/es/roofingLight.json"
import { applyLandingBrand } from "@/lib/siteHosts"
import CalculatorSection from "./calculator/CalculatorSection"
import LightFooter from "./footer/LightFooter"
import LightHeader from "./header/LightHeader"
import HeroSection from "./hero/HeroSection"
import LiveProofSection from "./liveProof/LiveProofSection"
import FieldResultsSection from "./fieldResults/FieldResultsSection"
import QuoteSection from "./fieldResults/QuoteSection"
import ForgeProofSection from "./forgeProof/ForgeProofSection"
import LeadInterceptionSection from "./leadInterception/LeadInterceptionSection"
import NotForSection from "./notFor/NotForSection"
import OriginSection from "./origin/OriginSection"
import OmnichannelSection from "./omnichannel/OmnichannelSection"
import SafetyNetSection from "./safetyNet/SafetyNetSection"
import SetupSection from "./setup/SetupSection"
import SundayGapSection from "./sundayGap/SundayGapSection"
import TestDriveSection from "./testDrive/TestDriveSection"
import { contentColumnClass, pageRootClass } from "./lightTheme"
import { useLandingCountry } from "./useLandingCountry"
import { useLandingLanguage } from "./useLandingLanguage"
import {
  LandingCountryDetectProvider,
  useLandingCountryDetect,
} from "./landingCountryDetect"
import { useLandingMarket } from "./useLandingMarket"

export default function RoofingLightLanding() {
  const country = useLandingCountry()
  const language = useLandingLanguage()
  const market = useLandingMarket()
  const detection = useLandingCountryDetect()
  const { search } = useLocation()

  useLayoutEffect(() => {
    document.documentElement.lang = language
    return () => {
      document.documentElement.lang = "en"
    }
  }, [language])

  useEffect(() => {
    let timeoutId = 0
    if (language === "es") {
      timeoutId = window.setTimeout(() => {
        document.title = applyLandingBrand(esCatalog.meta.title)
      }, 0)
    }
    return () => window.clearTimeout(timeoutId)
  }, [language, search])

  return (
    <LandingCountryDetectProvider value={detection}>
    <div
      className="roofing-light-canvas min-h-screen w-full bg-[#FAFAFA]"
      data-country={country || undefined}
      data-lang={language}
      data-market={market || undefined}
    >
      <LightHeader />
      <div className={`${pageRootClass} pt-0`}>
        <div className={contentColumnClass}>
          <HeroSection />
          <CalculatorSection />
          <OriginSection />
          <FieldResultsSection />
          <QuoteSection />
          <TestDriveSection />
          <SundayGapSection />
          <LiveProofSection />
          <SetupSection />
          <OmnichannelSection />
          <SafetyNetSection />
          <NotForSection />
          <LeadInterceptionSection />
          <ForgeProofSection />
        </div>
        <LightFooter />
      </div>
    </div>
    </LandingCountryDetectProvider>
  )
}
